import { ExamType } from '@tsin-core/entities';
import { ICreateExamFee, IUpdateExamFee } from '@tsin-core/models/exam-fee.model';

const ACTION_SCOPE = '[Exam Fees]';

export class CreateExamFee {
  static readonly type = `${ACTION_SCOPE} Create Exam Fee`;
  constructor(public payload: ICreateExamFee) {}
}

export class GetAllExamFees {
  static readonly type = `${ACTION_SCOPE} Get All Exam Fees`;
}

export class GetExamFeesByType {
  static readonly type = `${ACTION_SCOPE} Get Exam Fees By Type`;
  constructor(public examType: ExamType) {}

}

export class UpdateExamFees {
  static readonly type = `${ACTION_SCOPE} Update Exam Fees`
  constructor(public payload: IUpdateExamFee) {}
}

export class DeleteExamFees {
  static readonly type = `${ACTION_SCOPE} Delete Exam Fees`
  constructor(public id: string) {}
}